// extracted by mini-css-extract-plugin
export default {"modal":"SelectCandidateGroupModal-module__modal__Xl11+","detail":"SelectCandidateGroupModal-module__detail__qcgn7","content":"SelectCandidateGroupModal-module__content__0SCl3"};